<template>
  <grid-container-fi
    :container="false"
    class="podcasts-tabs-fi"
  >
    <tab-navigation-fi
      :tab-navigation="[
        { id: 0, text: $dict.get('podcasts.Highlights') },
        { id: 1, text: $dict.get('podcasts.Projects') },
      ]"
      hide-only
      class="fi-w-full"
      grid
      full-width-tabs
    >
      <template #tab-content-0>
        <div
          class="podcasts-tabs-fi__bg fi-col-span-12 fi-grid fi-grid-cols-12 fi-gap-small md:fi-gap-large"
        >
          <podcasts-list-fi :list="fields.podcastsHighlights" />
        </div>
      </template>
      <template #tab-content-1>
        <div
          class="podcasts-tabs-fi__bg fi-col-span-12 fi-grid fi-grid-cols-12 fi-gap-small md:fi-gap-large"
        >
          <podcasts-list-fi :list="fields.podcastsProjects" />
        </div>
      </template>
    </tab-navigation-fi>
  </grid-container-fi>
</template>

<script>
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import PodcastsListFi from '@/components/podcasts/podcasts-list-fi/PodcastsListFi.vue';
import TabNavigationFi from '@/components/tab-navigation-fi/TabNavigationFi.vue';

export default {
  name: 'PodcastsTabsFi',
  components: {
    GridContainerFi,
    PodcastsListFi,
    TabNavigationFi,
  },
  inject: ['fields'],
};
</script>

<style scoped src="./podcasts-tabs-fi" />
<style src="./podcasts-tabs-fi-unscoped" />
